import { Tags } from '@/features/single-measurement/types/tags';

export interface ITagOption {
  label: string;
  value: number | string;
}

export const mapTagsToLabels = (tags: Tags): ITagOption[] => {
  return [
    { label: 'tagLabels.tank', value: tags.tank },
    { label: 'tagLabels.tankVolume', value: tags.tankVolume },
    { label: 'tagLabels.yeastBrand', value: tags.yeastBrand },
    { label: 'tagLabels.yeastStrain', value: tags.yeastStrain },
    { label: 'tagLabels.yeastGeneration', value: tags.yeastGeneration },
    { label: 'tagLabels.grapeVariety', value: tags.grapeVariety },
    { label: 'tagLabels.vineyardSource', value: tags.vineyardSource },
    { label: 'tagLabels.grapeType', value: tags.oculyzeWineType },
    { label: 'tagLabels.nutrientsAtInoculation', value: tags.nutrientsAtFillIn },
    { label: 'tagLabels.additivesAtInoculation', value: tags.additivesAtFillIn },
  ];
};
